import { render, staticRenderFns } from "./CoursewareCommentsOverviewWidgetFilterUnit.vue?vue&type=template&id=3ebfc48e&"
import script from "./CoursewareCommentsOverviewWidgetFilterUnit.vue?vue&type=script&lang=js&"
export * from "./CoursewareCommentsOverviewWidgetFilterUnit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports